import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import LogoutButton from "./LogoutButton";
import { AuthenticatedRoute } from "src/auth/AuthenticatedRoute";

interface AdminLayoutProps {
  children?: React.ReactNode;
}

const NAV_LINKS = [
  { to: "/admin/eligibilities/upload", label: "Upload Eligibilities" },
  { to: "/admin/eligibilities/history", label: "History" },
];

const AdminLayout = ({ children }: AdminLayoutProps) => {
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col px-6 py-8 max-w-7xl mx-auto">
      <div className="w-full flex justify-between items-center p-4">
        <div className="flex items-center gap-6">
          <h1 className="text-2xl font-semibold text-gray-100">ADMIN PANEL</h1>
          <ul className="flex gap-6">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={`text-gray-200 hover:text-white px-2 py-1 rounded transition-colors ${
                    location.pathname === link.to ? "underline" : ""
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <LogoutButton />
      </div>
      <div className="flex-1 p-4">
        {children ? (
          children
        ) : (
          <AuthenticatedRoute>
            <Outlet />
          </AuthenticatedRoute>
        )}
      </div>
    </div>
  );
};

export default AdminLayout;
